import { IconBase, IconComponent } from './BaseIcon';

export const Upload: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M29.71 16.52v10.1a4.42 4.42 0 0 1-2.37.54H4.57a4.43 4.43 0 0 1-2.28-.54v-10.1H0v10.29c0 1.55 1.86 2.64 4.57 2.64h22.77c2.74 0 4.66-1.15 4.66-2.67V16.5Zm-14.76-9.6v12.97h2.28V6.94L19.3 9l1.61-1.61-4.82-4.83-4.8 4.81 1.61 1.62 2.06-2.06Z" />
  </IconBase>
);
